import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APINganHang = {
  LIST_NGAN_HANG: `${BASE_API_URL_CAP_DIEN}/ngan-hang/list`,
  SYNC_NGAN_HANG: `${BASE_API_URL_CAP_DIEN}/ngan-hang/sync`,
  GET_NGAN_HANG: `${BASE_API_URL_CAP_DIEN}/ngan-hang/get`,
  CREATE_NGAN_HANG: `${BASE_API_URL_CAP_DIEN}/ngan-hang/create`,
  UPDATE_NGAN_HANG: `${BASE_API_URL_CAP_DIEN}/ngan-hang/update`,
  REMOVE_NGAN_HANG: `${BASE_API_URL_CAP_DIEN}/ngan-hang/delete`,
};
